import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { DxToolbar } from 'devextreme-vue/toolbar';


export default /*@__PURE__*/_defineComponent({
  __name: 'toolbar-form',
  props: {
    isEditing: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    allowEdit: { type: Boolean, default: true }
  },
  emits: ['editCanceled', 'saveClicked', 'editToggled'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toolbarItems = computed(() => {
  const items: any[] = [];

  if (!props.isEditing && !props.isDisabled && props.allowEdit) {
    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Editează',
        icon: 'edit',
        stylingMode: 'outlined',
        type: 'default',
        onClick: () => emit('editToggled')
      }
    });
  }

  if (props.isEditing) {
    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Salvează',
        stylingMode: 'outlined',
        type: 'default',
        onClick: (e: any) => emit('saveClicked', e)
      }
    });

    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Anulează',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => emit('editCanceled')
      }
    });
  }

  return items;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxToolbar), { items: toolbarItems.value }, null, 8, ["items"]))
}
}

})